var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-body",style:(`padding-bottom:${_vm.needMarginBottom ? '74px' : ''}`)},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }